import i18n, { t } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import OCCOBackend from './i18nOCCOBackend.js';

/*
 * @param {Object} params
 * @param {number} params.orgId
 * @param {string} paras.eventCode
 * @param {'webapp'|'universal-kiosk'} params.projectName
 */
export async function initLoc({ orgId, eventCode, projectName }) {
  await i18n
    .use(LanguageDetector)
    .use(OCCOBackend)
    .init({
      fallbackLng: 'en',
      load: 'languageOnly',
      debug: true,
      supportedLngs: ['en'],
      backend: {
        cdn: process.env.LOCALIZATION_CDN,
        orgId,
        eventCode,
        projectName,
      },
      ns: ['common'],
      defaultNS: 'common',
    });
}

export { t };

export async function changeLanguage(lng) {
  return i18n.changeLanguage(lng);
}

export function getCurrentLanguage() {
  return i18n.language;
}
